export default defineAppConfig({
  foo: 'bar',
})
